export default function MetaData({ meta }: { meta?: Record<string, any> }) {
  return (
    <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
      {meta && JSON.stringify(meta, null, 2)}
    </pre>
  );
}
